import { GridEditorField, ControlType, FilterMatchMode } from '@identic/controls';

export const listFields: GridEditorField[] = [
  {
    field: 'name', header: 'Name', required: true,
    filterMatchMode: FilterMatchMode.contains,
    gridClass: 'col-md-6',
    detailRow: 0, detailClass: 'col-md-6',
    sortable: true,
  },
  {
    field: 'morphology_code', header: 'Morphology Code', required: true,
    filterMatchMode: FilterMatchMode.contains,
    gridClass: 'col-md-3',
    detailRow: 0, detailClass: 'col-md-6',
    sortable: true,
  },
  {
    field: 'hex_colour', header: 'Colour', required: true,
    filterMatchMode: FilterMatchMode.contains,
    gridClass: 'col-md-1',
    detailRow: 1, detailClass: 'col-md-12',
    sortable: true,
    controlType: ControlType.colour,
  },

  {
    field: 'actions', header: '',
    gridClass: 'col-md-2',
    detailHide: true,
    actions: {
      showAdd: { class: 'grid-header-row' },
      showDel: { class: 'grid-header-row' },
      showEdit: { class: 'grid-header-row' },
      showView: false,
      showReload: { class: 'grid-header-row' }
    },
    controlType: ControlType.custom
  },
  { field: 'id', header: 'Id', gridHide: true, detailHide: true },
];
